// Service partage de comptage des messages non-lus (pastilles messagerie), commun aux
// modules MS (/subsequents) et BDC (/bdc). Parametre PAR MODULE (prefixe d'endpoint via Core)
// et PAR ROLE (auteur_type). C'est la source unique : les hooks de detail et les listes en
// derivent, plutot que de dupliquer le fetch cote acheteur et cote prestataire.

export type MessagerieModule = '/subsequents' | '/bdc';
export type MessagerieAuteurType = 'acheteur' | 'prestataire';

export interface UnreadCounts {
  questions_reponses: number;
  messagerie: number;
}

const authedHeaders = (): HeadersInit => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  Accept: 'application/json',
});

// Compteurs de non-lus en BATCH : N operations -> 1 seule requete. Retourne la map brute
// { [operationId]: UnreadCounts } telle que renvoyee par le backend (les operations sans
// non-lu sont absentes). `extraParams` : query string additionnelle deja encodee (ex. `since[]`).
export const fetchUnreadCountsMap = async (
  module: MessagerieModule,
  auteurType: MessagerieAuteurType,
  operationIds: Array<number | string>,
  extraParams = '',
): Promise<Record<string, UnreadCounts>> => {
  if (operationIds.length === 0) return {};
  const params = operationIds.map((id) => `operation_ids[]=${id}`).join('&');
  const suffix = extraParams ? `&${extraParams}` : '';
  const url = `${process.env.REACT_APP_API_URL}${module}/messages/unread-counts?${params}&auteur_type=${auteurType}${suffix}`;

  const res = await fetch(url, { headers: authedHeaders() });
  if (!res.ok) return {};
  const json = await res.json().catch(() => null);
  return (json?.data as Record<string, UnreadCounts>) ?? {};
};

// Compteurs pour UNE operation (pages de detail). Delegue au batch et projette l'entree.
export const fetchUnreadCounts = async (
  module: MessagerieModule,
  auteurType: MessagerieAuteurType,
  operationId: number | string,
): Promise<UnreadCounts | null> => {
  const map = await fetchUnreadCountsMap(module, auteurType, [operationId]);
  return map[String(operationId)] ?? null;
};
